// React / Next
import { createFileRoute, redirect } from '@tanstack/react-router';

// Lib
import { getLandingPageBySlug } from '../lib/sanity/queries';

// Components
import { LandingPage } from '../pages/LandingPage/LandingPage';

/**
 * Landing Page Dynamic Route
 * Path: /landing-pages/:slug
 * Fetches landing page content from Sanity by slug
 */
export const Route = createFileRoute('/landing-pages/$slug')({
  loader: async ({ params }) => {
    const landing = await getLandingPageBySlug(params.slug);
    if (!landing) {
      throw redirect({ to: '/404' });
    }

    return { landing };
  },
  component: LandingPageWrapper,
});

function LandingPageWrapper() {
  const { landing } = Route.useLoaderData();
  return <LandingPage landing={landing} />;
}
